import API from "@/config/api";

async function getAccessToken() {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await API.generalRequest.get('auth', { withCredentials: true });
            resolve(response.data.data[0].accessToken)
        } catch (error) {
            const newErr = new Error("Unable to get access token");
            newErr.error = error;
            newErr.code = 401;
            reject(newErr);
        }
    });
}
export default getAccessToken;